@if((informationLoaded$ | async) && (customersLoaded$|async) && (meteringPointsLoaded$|async)) {
    <div>
        <app-carousel-display [informationGroup]="(informationGroup$|async)" 
            [showIsRead]="true" 
            [customers]="(customers$|async)"
            [meteringPoints]="(meteringPoints$|async)"
            [userType]="(userType$|async)"></app-carousel-display>
    </div>
}

